export default "__VITE_ASSET__DpTJo9jC__"